import React, { useEffect, useRef } from "react";
import CommonTile from "../component/commonTile";
import { connect } from "dva";
import { Link } from 'react-router-dom'
// import Swiper from "swiper";
// import "swiper/css/swiper.css";

import "./index.less";
import RcQueueAnim from "rc-queue-anim";
import { OverPack } from "rc-scroll-anim";
const Page8 = (props) => {
  // const swiperRef = useRef(null);

  // useEffect(() => {
  //   swiperRef.current = new Swiper(".swiper-container-new", {
  //     // autoplay: false, //可选选项，自动滑动
  //     speed: 800, // 切换速度
  //     loop: true, // 循环模式选项
  //     spaceBetween: 10,
  //     slidesPerView: 1,
  //     effect: "fade",
  //   });
  //   return () => {
  //     if (swiperRef.current) {
  //       swiperRef.current.destroy();
  //     }
  //   };
  // }, []);

  useEffect(() => {
    props.dispatch({
      type: "news/getHotNewList",
      payload: { pageNum: 1, hot: 1, pageSize: 4 },
      _isBrowser: false,
    });

    props.dispatch({ type: 'news/getNewList', payload: { pageNum: 1, pageSize: 1, hot: 0, type: 0 }, _isBrowser: false })
  }, []);

  // const onLeft = () => {
  //   if (swiperRef.current) {
  //     swiperRef.current.slidePrev();
  //   }
  // };
  // const onRight = () => {
  //   if (swiperRef.current) {
  //     swiperRef.current.slideNext();
  //   }
  // };

  return (
    <OverPack playScale={0.15} always={false} className="home-info">
      <CommonTile enTitle="INFO" title="实时资讯" />
      <RcQueueAnim type={'scale'}>
        <div key={1} className="home-info-inner">
          {
                props.list && props.list[0] &&  <Link
                key={props.list[0].id}
                to={`/newDetail/${props.list[0].id}`}
              ><div className="news-banner">
                <img src={props.list[0].icon} />
                <div className="news-text">
                  <div className="news-title">
                    {/* <span className='news-tag'>公司快讯</span> */}
                    <p>{props.list[0].title}</p>
                  </div>
                  <div className="news-desc">
                  {props.list[0].brief}
                  </div>
                  <div className="news-date">{props.list[0].createTime}</div>
                </div>
              </div></Link>
              }
          {/* <div className="swiper-container swiper-container-new">
            <div className="swiper-wrapper" style={{ width: 600 }}>
              <div className="swiper-slide news-banner" key="new2">
                <img src="https://www.dataqin.com/file/2023/04/10/9b904f327d190b7403a8aada9e08e2a2.jpg" />
                <div className="news-text">
                  <div className="news-title">
                    <span className="news-tag">公司快讯</span>
                    <p>2024未来数商大会 | 可信数据技术推</p>
                  </div>
                  <div className="news-desc">
                    2024未来数商大会在杭州开幕。本届大会以“场景突破
                    乘数而上”为主题，数秦科技董事长高航受邀出席大会并发表《区块链技术赋能数据要素循环》主题演讲
                  </div>
                  <div className="news-date">2024-09-02</div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className='news-option'>
                  <div className={`option-pre`} type="left" key="left" onClick={() => onLeft()} >
                    <svg t="1593416730015" className="pre-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5141" width="200" height="200"><path d="M294.13376 512c0-13.70112 5.23264-27.40224 15.6672-37.84704l328.704-328.69376c20.91008-20.91008 54.80448-20.91008 75.70432 0 20.89984 20.89984 20.89984 54.79424 0 75.70432L423.36256 512l290.83648 290.83648c20.89984 20.89984 20.89984 54.80448 0 75.70432-20.89984 20.91008-54.79424 20.91008-75.70432 0l-328.704-328.69376C299.35616 539.40224 294.13376 525.70112 294.13376 512z" p-id="5142"></path></svg>
                  </div>
                  <div className={`option-next`} type="right" key="right" onClick={() =>onRight()}>
                      <svg t="1593396482499" className="pre-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5119" width="200" height="200"><path d="M771.584 512L481.792 222.293333a42.666667 42.666667 0 1 1 60.416-60.330666l319.829333 319.829333a42.666667 42.666667 0 0 1 0 60.416l-319.829333 319.829333a42.666667 42.666667 0 0 1-60.416-60.330666L771.584 512z" p-id="5120"></path></svg>
                  </div>
                </div> */}
          <div>
            <div className="news-right">
              <div className="news-right-title">
                <span>公司快讯</span>
                <Link to="/news">查看更多</Link>
              </div>
              {props.hotlist &&
                props.hotlist.map((item, index) => (
                  <Link
                    key={item.id}
                    to={`/newDetail/${item.id}`}
                  >
                    <div className="news-right-content">
                      <div className="news-right-content-img-container">
                        <img src={item.icon} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <p>{item.brief}</p>
                        <span>{item.createTime}</span>
                      </div>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </RcQueueAnim>
    </OverPack>
  );
};

const mapStateToProps = (state) => ({
  hotlist: state.news.hotnews,
  list: state.news.record || [],
  // topNew: state.news.topNew,
  // // hotlist: state.news.hotnews,
  // brieflist: state.news.brieflist,
  // currentTitle: state.news.currentTitle,
  // total: state.news.total,
  // currentPage: state.news.currentPage,
  // currentType: state.news.currentType,
  // noMore: state.news.noMore,
});
export default connect(mapStateToProps)(Page8);
